export default {
  anoSelected : null,
  mesSelected : null,
  anos : [],
  meses : [],
  user : {
    roles : ''
  },
  competenciaOpen: null,
  indicadorList : [],
  competenciaList : [],
  centroCustoList : [],
  centroCustoSelected: null,
  competenciaSelected : null,
  periodoSelected : null,
  userList : [],
  arvoreList : [],
  periodoList : [],
  filterUpdatedAt: null,
  redirect : "",
  processoList : []
}



// WEBPACK FOOTER //
// ./src/store/state.js